<template>
  <article class="m-card-element m-card-element-design-4 m-card-primary m-card-transition">

    <div class="m-card-element-info-data">
      <AtomListElementActionsSecondary
        v-if="!hideMoveIcon"
        :element="element"
      />
      <AtomListElementActionsPrimary
        :element="element"
      />

      <div
        v-if="showSelected && parseInt($route.params.subid) === 4"
        class="m-card-element-info-data-selected"
      >
        {{ $t('mFeedSectionContentCardDesing4.selected') }}
      </div>

      <h5
        v-if="element.categoria"
        key="categoryName"
      >
        {{ productoCategoriaNombre }}
      </h5>
      <h5
        v-else
        key="noCategoryName"
      >
        {{ $t('mFeedSectionContentCardDesing4.noCategoryName') }}
      </h5>

      <h2 class="m-card-element-design-4-name">
        {{ element.nombre }}
      </h2>

      <div class="m-card-element-design-4-assets-included">
        <p
          v-for="i in 3"
          :key="`descripcion-${i}`"
        >
          <img
            v-if="tarjeta.metadata[`imagen${i}`]"
            :alt="element.nombre"
            :id="`cardImg-${i}`"
            :src="tarjeta.metadata[`imagen${i}`]"
          >
          <img
            v-else
            :alt="element.nombre"
            :id="`cardImg-${i}`"
            src="@/assets/img/ds4.png"
          >
          <span>
            {{ tarjeta.metadata[`texto${i}`] ? tarjeta.metadata[`texto${i}`] : genericParagraph }}
          </span>
        </p>
      </div>
    </div>

    <div class="m-card-element-info-state">
      <div class="m-card-element-info-state-of-access">
        <h3
          v-if="element.activo"
          key="available"
        >
         {{ $t('mFeedSectionContentCardDesing4.available') }}
        </h3>
        <h3
          v-else
          key="notAvailable"
        >
          {{ $t('mFeedSectionContentCardDesing4.notAvailable') }}
        </h3>
        <h4
          v-if="element.visible"
          key="visible"
        >
          {{ $t('mFeedSectionContentCardDesing4.visible') }}
        </h4>
        <h4
          v-else
          key="hidden"
        >
          {{ $t('mFeedSectionContentCardDesing4.hidden') }}
        </h4>
      </div>
      <router-link
        class="m-card-element-info-state-of-price"
        :to="`/${$t('rPaths.product')}/${element.id}/${$t('mEditionMenu.product.pricesAndPlans.subject')}`"
      >
        {{ productoPrecio }}
      </router-link>
    </div>

  </article>
</template>

<script>
export default {
  name: 'MoleculeFeedSectionContentCardDesign4',

  props: {
    element: Object,
    elementCategorias: Array,
    hideMoveIcon: {
      type: Boolean,
      default: false
    },
    showSelected: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      genericParagraph: '',

      tarjeta: {
        tipo: 4,
        metadata: {
          imagen1: '',
          imagen2: '',
          imagen3: '',
          texto1: '',
          texto2: '',
          texto3: ''
        }
      }
    }
  },

  computed: {
    productoCategoriaNombre () {
      return this.element.categoria.nombre !== undefined
        ? this.element.categoria.nombre
        : this.elementCategorias.find(categoria => categoria.id_producto_categoria === this.element.categoria.id_producto_categoria).nombre
    },

    productoPrecio () {
      return this.element.pago ? this.$t('mFeedSectionContentCardDesing4.price.buy') : this.$t('mFeedSectionContentCardDesing4.price.free')
    }
  },

  created () {
    if (this.element.tarjeta && this.element.tarjeta === 4) {
      this.tarjeta = Object.assign({}, { tipo: this.element.tarjeta, metadata: Object.assign({}, this.element.metadata) })
    }

    this.genericParagraph = this.$t('mFeedSectionContentCardEditionDesign4.messages.genericParagraph')
  }
}
</script>
